module.exports = "../../../../platform/assets/pageMainIcon/cd-personnel-approver.svg";